"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FrostyEffectHandler = exports.FrostyEffectArgs = void 0;
const __1 = require("../../..");
const EventType_1 = require("../../events/EventType");
const Schedule_1 = require("../../Schedule");
const Registries_1 = require("../../state/Registries");
const EffectType_1 = require("../EffectType");
const core_1 = require("../../vfx/core");
const LocationSelector_1 = require("../../vfx/LocationSelector");
class FrostyEffectArgs {
    constructor() {
        this.__type = EffectType_1.EffectType.Frosty;
        this.__typeName = "Frosty";
        this.name = "Frosty";
        this.harmful = true;
    }
}
exports.FrostyEffectArgs = FrostyEffectArgs;
let FrostyEffectHandler = class FrostyEffectHandler {
    apply(sequence, container, state) {
        const scriptArgs = {
            frostyEffectId: state.id,
            frostyApplierId: state.creatorId
        };
        state.meta.eventHandlerId = container.registerEventHandler(state.targetId, EventType_1.EventType.TurnStarted, Schedule_1.Schedule.Unlimited, new __1.CustomScriptEventHandlerArgs("Effect_Frosty_OnThirdTurnStarted", scriptArgs));
        const frostVfx = new core_1.AuraVfxStepArgs(new LocationSelector_1.ActorVfxLocationSelector(state.targetId, "chest"), "Frost");
        state.meta.vfxStepArgsId = frostVfx.id;
        sequence.push(frostVfx);
    }
    remove(sequence, container, state) {
        container.cancelEventHandler(state.meta.eventHandlerId);
        sequence.push(new core_1.CancelAuraVfxStepArgs(state.meta.vfxStepArgsId));
    }
};
FrostyEffectHandler = __decorate([
    Registries_1.Effects.register(EffectType_1.EffectType.Frosty)
], FrostyEffectHandler);
exports.FrostyEffectHandler = FrostyEffectHandler;
